// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file encryption/encryption_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type {
  DeviceKeyPackagesCount,
  E2eeCommit,
  E2eeWelcome,
  UserDeviceKeyPackage,
} from './encryption_model_pb';
import { file_encryption_encryption_model } from './encryption_model_pb';

/**
 * Describes the file encryption/encryption_response.proto.
 */
export const file_encryption_encryption_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_common_common_responses, file_encryption_encryption_model]
  );

/**
 * @generated from message com.gem.bff.contract.GetCommitsResponse
 */
export type GetCommitsResponse = Message<'com.gem.bff.contract.GetCommitsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetCommitsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCommitsSuccess success = 1;
         */
        value: GetCommitsSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetCommitsResponse.
 * Use `create(GetCommitsResponseSchema)` to create a new message.
 */
export const GetCommitsResponseSchema: GenMessage<GetCommitsResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 0);

/**
 * @generated from message com.gem.bff.contract.GetCommitsSuccess
 */
export type GetCommitsSuccess = Message<'com.gem.bff.contract.GetCommitsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.E2eeCommit commits = 1;
   */
  commits: E2eeCommit[];

  /**
   * @generated from field: optional string nextCursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetCommitsSuccess.
 * Use `create(GetCommitsSuccessSchema)` to create a new message.
 */
export const GetCommitsSuccessSchema: GenMessage<GetCommitsSuccess> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 1);

/**
 * @generated from message com.gem.bff.contract.GetWelcomesResponse
 */
export type GetWelcomesResponse = Message<'com.gem.bff.contract.GetWelcomesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetWelcomesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetWelcomesSuccess success = 1;
         */
        value: GetWelcomesSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetWelcomesResponse.
 * Use `create(GetWelcomesResponseSchema)` to create a new message.
 */
export const GetWelcomesResponseSchema: GenMessage<GetWelcomesResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 2);

/**
 * @generated from message com.gem.bff.contract.GetWelcomesSuccess
 */
export type GetWelcomesSuccess = Message<'com.gem.bff.contract.GetWelcomesSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.E2eeWelcome welcomes = 1;
   */
  welcomes: E2eeWelcome[];

  /**
   * @generated from field: optional string nextCursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetWelcomesSuccess.
 * Use `create(GetWelcomesSuccessSchema)` to create a new message.
 */
export const GetWelcomesSuccessSchema: GenMessage<GetWelcomesSuccess> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 3);

/**
 * @generated from message com.gem.bff.contract.AckWelcomesResponse
 */
export type AckWelcomesResponse = Message<'com.gem.bff.contract.AckWelcomesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.AckWelcomesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.AckWelcomesResponse.
 * Use `create(AckWelcomesResponseSchema)` to create a new message.
 */
export const AckWelcomesResponseSchema: GenMessage<AckWelcomesResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 4);

/**
 * @generated from message com.gem.bff.contract.ConsumeKeyPackagesByUserIdsResponse
 */
export type ConsumeKeyPackagesByUserIdsResponse =
  Message<'com.gem.bff.contract.ConsumeKeyPackagesByUserIdsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ConsumeKeyPackagesByUserIdsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.ConsumeKeyPackagesByUserIdsSuccess success = 1;
           */
          value: ConsumeKeyPackagesByUserIdsSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ConsumeKeyPackagesByUserIdsResponse.
 * Use `create(ConsumeKeyPackagesByUserIdsResponseSchema)` to create a new message.
 */
export const ConsumeKeyPackagesByUserIdsResponseSchema: GenMessage<ConsumeKeyPackagesByUserIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 5);

/**
 * @generated from message com.gem.bff.contract.ConsumeKeyPackagesByUserIdsSuccess
 */
export type ConsumeKeyPackagesByUserIdsSuccess =
  Message<'com.gem.bff.contract.ConsumeKeyPackagesByUserIdsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.UserDeviceKeyPackage keyPackages = 1;
     */
    keyPackages: UserDeviceKeyPackage[];
  };

/**
 * Describes the message com.gem.bff.contract.ConsumeKeyPackagesByUserIdsSuccess.
 * Use `create(ConsumeKeyPackagesByUserIdsSuccessSchema)` to create a new message.
 */
export const ConsumeKeyPackagesByUserIdsSuccessSchema: GenMessage<ConsumeKeyPackagesByUserIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 6);

/**
 * @generated from message com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdResponse
 */
export type ConsumeKeyPackagesByUserIdAndDeviceIdResponse =
  Message<'com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdSuccess success = 1;
           */
          value: ConsumeKeyPackagesByUserIdAndDeviceIdSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdResponse.
 * Use `create(ConsumeKeyPackagesByUserIdAndDeviceIdResponseSchema)` to create a new message.
 */
export const ConsumeKeyPackagesByUserIdAndDeviceIdResponseSchema: GenMessage<ConsumeKeyPackagesByUserIdAndDeviceIdResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 7);

/**
 * @generated from message com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdSuccess
 */
export type ConsumeKeyPackagesByUserIdAndDeviceIdSuccess =
  Message<'com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.UserDeviceKeyPackage keyPackages = 1;
     */
    keyPackages: UserDeviceKeyPackage[];
  };

/**
 * Describes the message com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdSuccess.
 * Use `create(ConsumeKeyPackagesByUserIdAndDeviceIdSuccessSchema)` to create a new message.
 */
export const ConsumeKeyPackagesByUserIdAndDeviceIdSuccessSchema: GenMessage<ConsumeKeyPackagesByUserIdAndDeviceIdSuccess> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 8);

/**
 * @generated from message com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceResponse
 */
export type GetKeyPackagesForUntrustedDeviceResponse =
  Message<'com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceSuccess success = 1;
           */
          value: GetKeyPackagesForUntrustedDeviceSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceResponse.
 * Use `create(GetKeyPackagesForUntrustedDeviceResponseSchema)` to create a new message.
 */
export const GetKeyPackagesForUntrustedDeviceResponseSchema: GenMessage<GetKeyPackagesForUntrustedDeviceResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 9);

/**
 * @generated from message com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceSuccess
 */
export type GetKeyPackagesForUntrustedDeviceSuccess =
  Message<'com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.UserDeviceKeyPackage keyPackages = 1;
     */
    keyPackages: UserDeviceKeyPackage[];

    /**
     * @generated from field: optional string nextCursor = 2;
     */
    nextCursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceSuccess.
 * Use `create(GetKeyPackagesForUntrustedDeviceSuccessSchema)` to create a new message.
 */
export const GetKeyPackagesForUntrustedDeviceSuccessSchema: GenMessage<GetKeyPackagesForUntrustedDeviceSuccess> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 10);

/**
 * @generated from message com.gem.bff.contract.UploadKeyPackagesResponse
 */
export type UploadKeyPackagesResponse =
  Message<'com.gem.bff.contract.UploadKeyPackagesResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UploadKeyPackagesResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UploadKeyPackagesResponse.
 * Use `create(UploadKeyPackagesResponseSchema)` to create a new message.
 */
export const UploadKeyPackagesResponseSchema: GenMessage<UploadKeyPackagesResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 11);

/**
 * @generated from message com.gem.bff.contract.ClearCurrentDeviceE2eeDataResponse
 */
export type ClearCurrentDeviceE2eeDataResponse =
  Message<'com.gem.bff.contract.ClearCurrentDeviceE2eeDataResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ClearCurrentDeviceE2eeDataResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ClearCurrentDeviceE2eeDataResponse.
 * Use `create(ClearCurrentDeviceE2eeDataResponseSchema)` to create a new message.
 */
export const ClearCurrentDeviceE2eeDataResponseSchema: GenMessage<ClearCurrentDeviceE2eeDataResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 12);

/**
 * @generated from message com.gem.bff.contract.GetKeyPackagesCountResponse
 */
export type GetKeyPackagesCountResponse =
  Message<'com.gem.bff.contract.GetKeyPackagesCountResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetKeyPackagesCountResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetKeyPackagesCountSuccess success = 1;
           */
          value: GetKeyPackagesCountSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetKeyPackagesCountResponse.
 * Use `create(GetKeyPackagesCountResponseSchema)` to create a new message.
 */
export const GetKeyPackagesCountResponseSchema: GenMessage<GetKeyPackagesCountResponse> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 13);

/**
 * @generated from message com.gem.bff.contract.GetKeyPackagesCountSuccess
 */
export type GetKeyPackagesCountSuccess =
  Message<'com.gem.bff.contract.GetKeyPackagesCountSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.DeviceKeyPackagesCount deviceKeyPackagesCount = 1;
     */
    deviceKeyPackagesCount: DeviceKeyPackagesCount[];
  };

/**
 * Describes the message com.gem.bff.contract.GetKeyPackagesCountSuccess.
 * Use `create(GetKeyPackagesCountSuccessSchema)` to create a new message.
 */
export const GetKeyPackagesCountSuccessSchema: GenMessage<GetKeyPackagesCountSuccess> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_response, 14);
